export default __webpack_public_path__ + "static/media/si-logo.e59c00bc.svg";